import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const searchProductsRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/products',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/products' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};
const searchProductsResponse: Json = {
    title: 'RESPONSE',
    json: {
        'totalCount': 2,
        'totalPages': 1,
        'pageNumber': 1,
        'pageSize': 100,
        'results': [
            {
                'id': 1,
                'number': 'BTY100',
                'description': 'Battery Pack',
                'sku': 'SKU-BTY100',
                'upc': '',
                'active': true,
                'isKit': false,
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'price': '29.99',
                'partNumber': 'B201',
                'partDescription': 'Battery',
                'partType': 'Inventory'
            },
            {
                'id': 2,
                'number': 'FG2100',
                'description': 'Extreme Mountain Bike',
                'sku': 'SKU-FG2100',
                'upc': '',
                'active': true,
                'isKit': false,
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'price': '599.99',
                'partNumber': 'FG2100',
                'partDescription': 'Extreme Mountain Bike',
                'partType': 'Inventory'
            }
        ]
    },
};

const searchProductsQueryParameters: Attribute[] = [
    {
        name: 'pageNumber',
        type: 'integer',
        optional: true,
        description: 'The current page of the results.'
    },
    {
        name: 'pageSize',
        type: 'integer',
        optional: true,
        description: 'The number of returned results per page. (Default 100)'
    },
    {
        name: 'number',
        type: 'string',
        optional: true,
        description: 'The product number.',
    },
    {
        name: 'description',
        type: 'string',
        optional: true,
        description: 'The product description.',
    },
    {
        name: 'details',
        type: 'string',
        optional: true,
        description: 'The product details.',
    },
    {
        name: 'sku',
        type: 'string',
        optional: true,
        description: 'The SKU for the product.',
    },
    {
        name: 'upc',
        type: 'string',
        optional: true,
        description: 'The UPC code for the product.',
    },
    {
        name: 'active',
        type: 'boolean',
        optional: true,
        description: 'The active status of the product.',
    },
    {
        name: 'isKit',
        type: 'boolean',
        optional: true,
        description: 'Filter by kit status. When true, only kit products are returned. When false, only non-kit products are returned. When omitted, both are returned.',
    },
    {
        name: 'partNumber',
        type: 'string',
        optional: true,
        description: 'The associated part number.',
    },
    {
        name: 'partDescription',
        type: 'string',
        optional: true,
        description: 'The associated part description.',
    },
    {
        name: 'partUpc',
        type: 'string',
        optional: true,
        description: 'The UPC code for the associated part.',
    },
    {
        name: 'vendorName',
        type: 'string',
        optional: true,
        description: 'The name of the associated vendor.',
    },
    {
        name: 'vendorPartNumber',
        type: 'string',
        optional: true,
        description: 'The vendor part number.',
    },
    {
        name: 'customerPartNumber',
        type: 'string',
        optional: true,
        description: 'The customer part number.',
    },
];

const searchProductsAttributes: Attribute[] = [
    {
        name: 'customFields',
        type: 'list',
        description: 'A list of the product\'s custom fields.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identifier for the custom field.',

            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
        ]
    }
];

const data: RequestDefinitionData = {
    id: 'search-product',
    title: 'Search for products',
    description: 'Searches for products.',
    endpoint: {
        verb: 'GET',
        path: '/products',
        tooltip: 'Search for products',
    },
    attributes: searchProductsAttributes,
    requestObject: searchProductsRequest,
    responseObject: searchProductsResponse,
    queryParameters: searchProductsQueryParameters,
}

export default data;
